export const FieldLimits = {
  company: 200,
  email: 254,
  goals: 4000,
  message: 4000,
  name: 200,
  phone: 30,
  serviceArea: 200,
  website: 300,
};